import { Autocomplete, Stack, Tag } from "@shopify/polaris";
import { FC, useCallback, useEffect, useState } from "react";
import styles from "../AddProductsUsingFiltersModal.module.css";
import { FieldRenderProps } from "react-final-form";

interface SelectedProductsFieldProps extends FieldRenderProps<any> {
}

const AutocompleteFormField: FC<SelectedProductsFieldProps> = ({ input, label, deselectedOptions, disabled }) => {
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [options, setOptions] = useState([]);

  useEffect(() => {
    if (deselectedOptions && deselectedOptions.length) {
      setOptions(deselectedOptions.map(option => ({ value: option, label: option })));
    }
  }, [deselectedOptions]);

  useEffect(() => {
    input.onChange(selectedOptions);
  }, [selectedOptions]);

  const updateText = useCallback(
    (value) => {
      setInputValue(value);
      if (value === "") {
        setOptions(deselectedOptions);
        return;
      }

      const resultOptions = deselectedOptions.filter((option) => option.label.match(value, 1));
      if (resultOptions.length === 0) {
        setOptions([{ value, label: value }]);
        return;
      }
      setOptions(resultOptions);
    },
    [deselectedOptions, options]
  );

  const removeTag = useCallback(
    (tag) => () => {
      const options = [...selectedOptions];
      options.splice(options.indexOf(tag), 1);
      setSelectedOptions(options);
    },
    [selectedOptions]
  );

  const verticalContentMarkup =
    selectedOptions.length > 0 ? (
      <Stack spacing="extraTight" alignment="center">
        {selectedOptions.map((option) => {
          let tagLabel = "";
          tagLabel = option.replace("_", " ");
          tagLabel = titleCase(tagLabel);
          return (
            <Tag key={`option${option}`} onRemove={removeTag(option)}>
              {tagLabel}
            </Tag>
          );
        })}
      </Stack>
    ) : null;


  const textField = (
    <div className={styles.inputWrapper}>
      <Autocomplete.TextField
        onChange={updateText}
        label={label}
        value={inputValue}
        placeholder="Select"
        verticalContent={verticalContentMarkup}
        disabled={disabled}
        autoComplete={"false"}
      />
    </div>
  );

  return (
    <Autocomplete
      allowMultiple
      options={options}
      selected={selectedOptions}
      textField={textField}
      onSelect={setSelectedOptions}
      listTitle={selectedOptions?.length ? "Suggested Tags" : "Suggested"}
    />
  );

  function titleCase(string) {
    return string
      .toLowerCase()
      .split(" ")
      .map((word) => word ? word.replace(word[0], word[0].toUpperCase()) : "")
      .join("");
  }
};

export default AutocompleteFormField;